import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import getHostDomain from 'helpers/getHostDomain';

import withStyles from '@material-ui/core/styles/withStyles';

import SplitPageContainer from 'components/SplitPageContainer';
import SplitPageRight from 'components/SplitPageRight';
import SamlButton from 'components/SignInMethodButtons/SamlButton';
import StandardButton from 'components/SignInMethodButtons/StandardButton';

import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import samlInit from 'helpers/samlInit';

const styles = theme => {
  return {
    header: {
      fontSize: 50.9,
      lineHeight: 1,
      color: theme.palette.primary.main,
      marginTop: theme.spacing(9),
      [theme.breakpoints.down('xs')]: {
        fontSize: 30.9,
        marginTop: theme.spacing(2),
      },
    },
    subheaderOne: {
      marginTop: theme.spacing(1),
      fontSize: 24,
      lineHeight: 1.41,
      letterSpacing: 0.2,
    },
    subheaderTwo: {
      display: 'block',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(6),
      fontSize: 17,
      letterSpacing: -0.1,
      height: 16,
    },
    button: {
      marginTop: theme.spacing(4),
      color: theme.palette.secondary.main,
    },
    loginButtonsContainer: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: theme.spacing(1.5),
      [theme.breakpoints.down('sm')]: {
        alignItems: 'center',
      },
    },
    buttonContainer: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignContent: 'flex-start',
      alignItems: 'flex-start',
      flexDirection: 'column',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
      },
    },
    preferredOption: {
      fontSize: 17,
      lineHeight: 1.41,
      letterSpacing: 0.2,
    },
    otherOption: {
      marginTop: theme.spacing(4),
    },
  };
};

const SignInButtons = {
  saml: SamlButton,
  standard: StandardButton,
};

class SignInMethod extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    loginDomains: PropTypes.array.isRequired,
    history: PropTypes.object.isRequired,
    additionalParams: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, loginDomains } = this.props;
    const firstSubdomainLoginOptions = _get(loginDomains, '[0].loginOptions');
    const id = _get(match, 'params.id');
    if (!firstSubdomainLoginOptions || !id) {
      this.props.history.replace(`/`);
      return null;
    }

    const { otherMethods, preferredMethods } = _get(loginDomains, `[${id}].loginOptions`, {});

    const isSignInMethodsValid =
      preferredMethods && otherMethods ? preferredMethods.concat(otherMethods) : [];

    if (isSignInMethodsValid.length === 1) {
      isSignInMethodsValid[0] === 'saml' ? this.samlSubmit() : this.handleStandardLogin();
    }
  }

  handleStandardLogin = () => {
    this.props.history.push(`/standard/0`);
  };

  renderPreferred = method => {
    return this.renderOptionsWithPreferred(true, method);
  };

  renderOther = method => {
    return this.renderOptionsWithPreferred(false, method);
  };

  renderOptionsWithPreferred = (preferred, method) => {
    let Component;
    let color;
    const { match, loginDomains } = this.props;
    if (preferred) {
      color = 'secondary';
    }
    if (SignInButtons[method]) {
      Component = SignInButtons[method];
      return (
        <Component
          color={color}
          key={method}
          history={this.props.history}
          match={this.props.match}
          loginOptionResponse={loginDomains[_get(match, 'params.id', null)]}
        />
      );
    }
  };

  samlSubmit = () => {
    const { loginDomains, match, additionalParams } = this.props;

    const loginOptionResponse = loginDomains[_get(match, 'params.id', null)];

    samlInit(loginOptionResponse, additionalParams);
  };

  render() {
    const { classes, match, loginDomains, history } = this.props;
    const selectedDomainIndex = _get(match, 'params.id', null);
    let otherOptionsHeader;
    if (!selectedDomainIndex || !_get(loginDomains[0], 'subdomain', null)) {
      return null;
    } else if (loginDomains[selectedDomainIndex].loginOptions.otherMethods.length > 0) {
      otherOptionsHeader = <Typography className={classes.otherOption}>Other Options</Typography>;
    }

    const hostDomain = getHostDomain();

    return (
      <SplitPageContainer>
        <SplitPageRight>
          <Typography className={classes.header} variant="h2">
            Choose a sign-in method
          </Typography>
          <Typography className={classes.subheaderOne} variant="body1">
            Company Name: {loginDomains[selectedDomainIndex].displayName}
          </Typography>
          <Typography className={classes.subheaderTwo} variant="h6">
            Company URL:{' '}
            <strong>
              {loginDomains[selectedDomainIndex].subdomain}.{hostDomain}.com
            </strong>
          </Typography>
          <Typography className={classes.preferredOption}>Preferred Options</Typography>
          <div className={classes.loginButtonsContainer}>
            {loginDomains[selectedDomainIndex].loginOptions.preferredMethods.map(
              this.renderPreferred,
            )}
            {otherOptionsHeader}
            {loginDomains[selectedDomainIndex].loginOptions.otherMethods.map(this.renderOther)}
          </div>
          <div className={classes.buttonContainer}>
            <Button className={classes.button} onClick={history.goBack}>
              Back
            </Button>
          </div>
        </SplitPageRight>
      </SplitPageContainer>
    );
  }
}

export default withStyles(styles)(SignInMethod);
